import { render, staticRenderFns } from "./ed-skeleton-loader.vue?vue&type=template&id=5c51ed9c&scoped=true&"
import script from "./ed-skeleton-loarder.ts?vue&type=script&lang=ts&"
export * from "./ed-skeleton-loarder.ts?vue&type=script&lang=ts&"
import style0 from "./ed-skeleton-loarder.scss?vue&type=style&index=0&id=5c51ed9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c51ed9c",
  null
  
)

export default component.exports